import './App.css'
import "@fortawesome/fontawesome-free/css/all.min.css"
import "./assets/styles/tailwind.css"

import { createContext, useReducer } from "react"
import { Switch, Route, Redirect } from 'react-router-dom'

import Admin from "./layouts/Admin.js";
import Auth from "./layouts/Auth.js";
import User from "./layouts/User.js"
import Index from "./views/Index.js";
export const AuthContext = createContext();

const initialState = {
  isAuthenticated: JSON.parse(localStorage.getItem("token")) ? true : false,
  role: JSON.parse(localStorage.getItem("role")) ? JSON.parse(localStorage.getItem("role")) : null,
  token: null,
};

const reducer = (state, action) => {
  localStorage.setItem("token", JSON.stringify(action.payload.token));
  localStorage.setItem("role", JSON.stringify(action.payload.role));
  return {
    ...state,
    isAuthenticated: true,
    role: action.payload.role,
    token: action.payload.token
  }
};

function App() {
  const [state, dispatch] = useReducer(reducer, initialState);
  return (
    <>
      <AuthContext.Provider
        value={{
          state,
          dispatch
        }}
      >
        <Switch>
          <Route path='/' component={Index} exact />
          <Route path="/auth" component={Auth} />
          {state.role === "user" && <Route path="/user" component={User} type="private" />}
          {state.role === "admin" && <Route path="/admin" component={Admin} type="private" />}
          {!state.isAuthenticated && <Redirect from="/:any" to="/auth" />}
        </Switch>
      </AuthContext.Provider>
    </>
  );
}

export default App;
